import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import routes from 'src/constants/routes.json';

export default class Header extends Component {
    render() {
        return (
            <div className="header bg-danger py-6">
                <div className="container-fluid">
                    <div className="header-body">
                        <div className="row align-items-center py-4">
                            <div className="col-lg-6 col-7">
                                <h6 className="h2 text-white d-inline-block mb-0">Terminais</h6>
                            </div>
                            <div className="col-lg-6 col-5 text-right">
                                {/* <Link to={routes.REQUEST_TERMINAL} className="btn btn-sm btn-default">Solicitar Terminal</Link> */}
                            </div>
                        </div> 
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Pages/Terminals/Header.js